import React, { useEffect, useRef, useState } from "react";

// Lightweight, dependency-free scroll reveal. Wraps a section and fades/slides
// it in once it enters the viewport. Falls back to visible if Intersection
// Observer is unavailable.
const Reveal = ({ children, className = "" }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      // threshold 0 = fire as soon as any part enters the viewport. (A higher
      // threshold never fires for sections taller than the viewport — e.g. the
      // 15-card Building Careers grid on mobile — leaving them stuck hidden.)
      { threshold: 0, rootMargin: "0px 0px -40px 0px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={`reveal-ed ${visible ? "is-visible" : ""} ${className}`}>
      {children}
    </div>
  );
};

export default Reveal;
